import { useCallback, useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export async function adminApi(path, opts = {}) {
  const res = await fetch(`${API}/api/admin-ai${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...opts,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Request failed');
  return data;
}

export default function useAdminAi() {
  const [health, setHealth] = useState(null);
  const [reports, setReports] = useState([]);
  const [changes, setChanges] = useState([]);
  const [faqs, setFaqs] = useState({ faqs: [], pending_questions: 0 });
  const [notes, setNotes] = useState([]);
  const [drafts, setDrafts] = useState([]);
  const [overrides, setOverrides] = useState([]);
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');

  const reload = useCallback(async () => {
    const [h, r, c, f, n, d, o] = await Promise.all([
      adminApi('/health'), adminApi('/beta/reports'), adminApi('/changes'), adminApi('/faqs'), adminApi('/notes'), adminApi('/help-drafts'), adminApi('/help-overrides'),
    ]);
    setHealth(h); setReports(r.reports); setChanges(c.changes); setFaqs(f); setNotes(n.notes); setDrafts(d.drafts); setOverrides(o.overrides);
  }, []);

  useEffect(() => { reload().catch((e) => setMsg(e.message)); }, [reload]);

  const run = async (key, path, opts, done) => {
    setBusy(key); setMsg('');
    try {
      const data = await adminApi(path, { method: 'POST', ...opts });
      setMsg(done(data));
      await reload();
    } catch (e) {
      setMsg(e.message);
    } finally {
      setBusy('');
    }
  };

  return { health, reports, changes, faqs, notes, drafts, overrides, busy, msg, run, reload, setMsg };
}
